import { ClassValue, clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

/**
 * CONVENÇÃO: Sempre usar esta função ao invés de setTimeout para delays
 * 
 * @param ms - Tempo em milissegundos para aguardar
 * @returns Promise que resolve após o tempo especificado
 * 
 * @example
 * // ❌ NÃO fazer:
 * setTimeout(() => doSomething(), 1000);
 * 
 * // ✅ FAZER:
 * delay(1000).then(() => doSomething());
 * 
 * // ✅ OU com async/await:
 * await delay(1000);
 * doSomething();
 * 
 * @usage
 * - API simulation: await delay(500)
 * - UI feedback: delay(1500).then(() => navigate())
 * - DOM updates: delay(200).then(() => scrollToElement())
 * - Animation timing: delay(50).then(() => triggerAnimation())
 */
export const delay = (ms: number) => 
  new Promise((resolve) => setTimeout(resolve, ms));

export const generateUID = () => {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
    const r = Math.random() * 16 | 0,
      v = c === 'x' ? r : (r & 0x3 | 0x8);
    return v.toString(16);
  });
};

export const createMockData = <T>(defaultData: T, overrides?: Partial<T>): T => {
  return {
    ...defaultData,
    ...overrides,
    id: generateUID(),
    createdAt: new Date(),
    updatedAt: new Date(),
  };
};
